import { Component, Input, OnInit } from '@angular/core';
import { CompanyService, NgxToastrService } from '@services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-policies-modal',
  templateUrl: './policies-modal.component.html',
  styleUrls: ['./policies-modal.component.scss'],
})
export class PoliciesModalComponent implements OnInit {
  @Input() company: any;
  @Input() policies: any[] = [];
  deletedAnyPolicy = false;

  constructor(public activeModal: NgbActiveModal, private companyService: CompanyService,
              private ngxToastrService: NgxToastrService, private translate: TranslateService,
              private router: Router
  ) {}

  ngOnInit(): void {
    this.policies = this.policies.sort((a, b) => {
      if (a.name === 'Default') return -1;
      if (b.name === 'Default') return 1;
      return a.name.localeCompare(b.name);
    });
  }

  editPolicy(travelPolicy: any) {
    const navigation: NavigationExtras = {
        state: {
        loading: false,
        company: this.company,
        ...(travelPolicy?.uuid && { travelPolicy }),
      },
    };
    
    const route = travelPolicy?.uuid
      ? ["group/edit-group/", travelPolicy.uuid]
      : ["group/create-group"];
    
    this.activeModal.dismiss();
    this.router.navigate(route, navigation);
  }

  deletePolicy(policy: any) {
    this.companyService.deleteCompanyPolicy(this.company.uuid, policy.uuid).subscribe({
      next: () => {
        this.policies = this.policies.filter(p => p.uuid !== policy.uuid);
        this.deletedAnyPolicy = true;
        this.translate.get("common.policies.delete").subscribe((result) => {
          this.ngxToastrService.typeSuccess(result, "");
        });
      },
      error: (error) => {
        this.translate.get("common.policies.delete-error").subscribe((result) => {
          this.ngxToastrService.typeSuccess(result, "");
        });
      }
    });
  }

  createPolicy() {
    const navigation: NavigationExtras = {
          state: {
            loading: false,
            company: this.company,
          },
        };

    this.activeModal.dismiss();
    this.router.navigate(["group/create-group"], navigation);
  }

  closeModal() {
    this.activeModal.close({ deleted: this.deletedAnyPolicy });
  }

  getPolicyTooltip(policy: any): string {
    const f = policy.filters;

    return `
      ${this.translate.instant('common.stars')}: ${f?.stars ?? '-'}
      ${this.translate.instant('common.policies.hotel-price')}: ${f?.priceMin ?? '-'} - ${f?.priceMax ?? '-'}
      ${this.translate.instant('search.card.breakfast')}: ${f?.breakfast ? this.translate.instant('common.yes') : this.translate.instant('common.no')}
      ${this.translate.instant('company.company-booked.room-type')}: ${f?.lodgingType ?? '-'}
      ${this.translate.instant('common.policies.only-auth-hotel')}: ${f?.onlyAuthorization ? this.translate.instant('common.yes') : this.translate.instant('common.no')}
      ${this.translate.instant('group.group-form.book-allowed')}: ${f?.requestBooked ? this.translate.instant('common.yes') : this.translate.instant('common.no')}
      ${this.translate.instant('common.policies.custom-hotel')}: ${f?.requestCustomBooking ? this.translate.instant('common.yes') : this.translate.instant('common.no')}
      ${this.translate.instant('common.policies.custom-airbnb')}: ${f?.requestCustomAirbnb ? this.translate.instant('common.yes') : this.translate.instant('common.no')}
      ${this.translate.instant('common.policies.days-advance-hotel')}: ${f?.hotelDaysInAdvance ?? '0'}
      ${this.translate.instant('group.group-form.price-location')}: ${f?.pricesByLocation?.length ? f.pricesByLocation.map(p => `${p.placeName}: ${p.priceMax}`).join(', ') : this.translate.instant('common.none')}

      ${this.translate.instant('common.policies.flight-price')}: ${f?.priceMinFlight ?? '-'} - ${f?.priceMaxFlight ?? '-'}
      ${this.translate.instant('common.policies.only-auth-flight')}: ${f?.onlyFlightAuthorization ? this.translate.instant('common.yes') : this.translate.instant('common.no')}
      ${this.translate.instant('company.group.group-form.flight-allowed')}: ${f?.requestFlight ? this.translate.instant('common.yes') : this.translate.instant('common.no')}
      ${this.translate.instant('common.policies.custom-flight')}: ${f?.requestCustomFlight ? this.translate.instant('common.yes') : this.translate.instant('common.no')}
      ${this.translate.instant('common.policies.days-advance-flight')}: ${f?.flightDaysInAdvance ?? '0'}
      ${this.translate.instant('common.policies.duration-flight')}: ${
            f?.allowAmountOverDuration ? `${this.translate.instant('common.policies.price-until')} ${f.allowAmountOverDuration.amount}, ${this.translate.instant('common.policies.max-duration')} ${f.allowAmountOverDuration.duration} h` : this.translate.instant('common.none')
          }

      ${this.translate.instant('common.policies.train-budget')}: ${f?.trainMaxBudgetPercentage != null ? f.trainMaxBudgetPercentage + '%' : '-'}
      ${this.translate.instant('common.policies.only-auth-train')}: ${f?.onlyTrainAuthorization ? this.translate.instant('common.yes') : this.translate.instant('common.no')}
      ${this.translate.instant('company.group.group-form.train-allowed')}: ${f?.requestTrain ? this.translate.instant('common.yes') : this.translate.instant('common.no')}
      ${this.translate.instant('common.policies.custom-train')}: ${f?.requestCustomTrain ? this.translate.instant('common.yes') : this.translate.instant('common.no')}
      ${this.translate.instant('common.policies.days-advance-train')}: ${f?.trainDaysInAdvance ?? '0'}
      
      ${this.translate.instant('company.group.group-form.requestCar-allowed')}: ${f?.requestCar ? this.translate.instant('common.yes') : this.translate.instant('common.no')}

    `;
  }
  
}
